var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchema = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    fillRule: "evenodd",
    d: "M1.91 1.356h10.18c.626 0 1.132.557 1.132 1.244s-.506 1.244-1.131 1.244H1.909C1.284 3.844.778 3.287.778 2.6s.506-1.244 1.131-1.244M12.09.5C13.146.5 14 1.44 14 2.6s-.855 2.1-1.91 2.1H1.91C.854 4.7 0 3.76 0 2.6S.855.5 1.91.5zM13 7.472c0-.236-.175-.428-.39-.428H5.389c-.214 0-.389.192-.389.428s.175.428.39.428h7.222c.214 0 .388-.192.388-.428m-.39 2.872c.215 0 .39.192.39.428s-.175.428-.39.428H5.389c-.214 0-.389-.192-.389-.428s.175-.428.39-.428zm.39 3.728c0-.236-.175-.427-.39-.427H5.389c-.214 0-.389.19-.389.427 0 .236.175.428.39.428h7.222c.214 0 .388-.192.388-.428M3.61 7.044c.215 0 .389.192.389.428s-.174.428-.389.428H1.39C1.174 7.9 1 7.708 1 7.472s.174-.428.389-.428zM4 10.772c0-.236-.174-.428-.389-.428H1.39c-.215 0-.389.192-.389.428s.174.428.389.428H3.61c.215 0 .389-.192.389-.428m-.389 2.873c.215 0 .389.19.389.427 0 .236-.174.428-.389.428H1.39c-.215 0-.389-.192-.389-.428s.174-.427.389-.427z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchema);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schema.8a9669d1.svg";